const CLASS_HIDDEN = 'd-none';
import { Controller } from 'stimulus';
import { t } from '../javascript/lib/i18n';
export default class extends Controller {
  static targets = [
    'facility',
    'patient',
    'patientOuter',
    'facilityOuter',
    'observations',
    'receiveObservations',
    'enableProgressNotes',
    'progressNotesMessage',
    'firstName',
    'lastName',
  ];
  static values = {
    patientUrl: String,
    facilityUrl: String,
    progressNoteStatusUrl: String,
    currentFacility: Number,
    currentPatient: Number,
    vipId: Number,
  };

  async connect() {
    var messageSpan = document.createElement('span');
    messageSpan.setAttribute('id', 'pcc_vip_search_message');
    messageSpan.classList.add('form-text');

    this.patientOuterTarget.append(messageSpan);

    var facilityMessageSpan = document.createElement('span');
    facilityMessageSpan.setAttribute('id', 'pcc_facility_search_message');
    facilityMessageSpan.classList.add('form-text');

    this.facilityOuterTarget.append(facilityMessageSpan);

    var options = await this.getFacilityOptions();

    await this.setFacilityOptions(options);

    this.showOrHideObsList();
    this.checkProgressNotesAvailability();
  }

  disconnect() {
    this.observationsTarget.classList.add(CLASS_HIDDEN);
    this.receiveObservationsTarget.classList.add(CLASS_HIDDEN);
    this.enableProgressNotesTarget.classList.add(CLASS_HIDDEN);
  }

  async showOrHideObsList() {
    if (this.facilityTarget.value && this.patientTarget.value) {
      // Reveal the elements while the API call is in progress
      this.observationsTarget.classList.remove(CLASS_HIDDEN);
      this.receiveObservationsTarget.classList.remove(CLASS_HIDDEN);
      this.enableProgressNotesTarget.classList.remove(CLASS_HIDDEN);
    } else {
      this.observationsTarget.classList.add(CLASS_HIDDEN);
      this.receiveObservationsTarget.classList.add(CLASS_HIDDEN);
      this.enableProgressNotesTarget.classList.add(CLASS_HIDDEN);
      this.progressNotesMessageTarget.classList.add(CLASS_HIDDEN);
    }
  }

  async checkProgressNotesAvailability() {
    if (!this.progressNoteStatusUrlValue) {
      return;
    }

    try {
      const response = await fetch(
        `${this.progressNoteStatusUrlValue}?vip_id=${this.vipIdValue}`,
        {
          method: 'GET',
          headers: this.headers,
        }
      );

      if (response.ok) {
        const data = await response.json();
        this.handleProgressNotesStatus(data.has_amba_note_type);
      } else {
        this.handleProgressNotesStatus(false);
      }
    } catch (error) {
      console.error('Error checking progress notes availability:', error);
      this.handleProgressNotesStatus(false);
    }
  }

  handleProgressNotesStatus(hasAmbaNoteType) {
    const checkbox = this.enableProgressNotesTarget.querySelector(
      'input[type="checkbox"]'
    );

    if (hasAmbaNoteType) {
      // Enable the checkbox and hide warning message
      if (checkbox) {
        checkbox.disabled = false;
      }
      this.progressNotesMessageTarget.classList.add(CLASS_HIDDEN);
    } else {
      // Disable the checkbox and show warning message
      if (checkbox) {
        checkbox.disabled = true;
        checkbox.checked = false;
      }
      this.progressNotesMessageTarget.classList.remove(CLASS_HIDDEN);
    }
  }

  async setFacilityOptions(options) {
    for (const option of options) {
      var opt = document.createElement('option');
      opt.value = option['value'];
      opt.innerHTML = option['label'];
      if (option['value'] == this.currentFacilityValue) {
        opt.selected = 'selected';
      }
      this.facilityTarget.appendChild(opt);
    }
    if (this.facilityTarget.value) {
      await this.updatePatients();
    }
  }

  async setPatientOptions(options) {
    this.patientTarget.innerHTML = '';

    var options_list;

    if (options.length > 0) {
      options_list = options;
    } else {
      options_list = [{ value: '', label: ' ' }];
    }

    for (const option of options_list) {
      var opt = document.createElement('option');
      opt.value = option['value'];
      opt.innerHTML = option['label'];
      if (
        option['value'] == this.currentPatientValue ||
        options['value'] == ''
      ) {
        opt.selected = 'selected';
      }
      this.patientTarget.appendChild(opt);
    }
  }

  async getFacilityOptions() {
    const response = await fetch(this.facilityUrlValue, {
      method: 'POST',
      headers: this.headers,
    });

    var options;

    if (response.ok) {
      options = await response.json();
    } else {
      this.setFacilityFieldMessage(t('js.pcc_lookup.facilities_unavailable'));
      window.sendError(
        `Error retrieving vip search results: ${response.statusText}`
      );
      options = [];
    }

    return options;
  }

  async setPatientFieldMessage(message) {
    var span = document.getElementById('pcc_vip_search_message');
    span.innerText = message;
  }

  async setFacilityFieldMessage(message) {
    var span = document.getElementById('pcc_facility_search_message');
    span.innerText = message;
  }

  async patientOptions() {
    if (
      this.facilityTarget.value == '' ||
      this.firstNameValue == '' ||
      this.lastNameValue == ''
    ) {
      return [];
    }

    var patient_url = this.patientUrlValue;
    patient_url =
      patient_url +
      '?' +
      '&facility_id=' +
      this.facilityTarget.value +
      '&first_name=' +
      this.firstNameTarget.value +
      '&last_name=' +
      this.lastNameTarget.value +
      '&vip_id=' +
      this.vipIdValue;

    const response = await fetch(patient_url, {
      method: 'POST',
      headers: this.headers,
    });

    var options;

    if (response.ok) {
      options = await response.json();
    } else {
      this.setPatientFieldMessage(t('js.pcc_lookup.residents_unavailable'));
      window.sendError(
        `Error retrieving vip search results: ${response.statusText}`
      );
    }

    return options;
  }

  async updatePatients() {
    var options = await this.patientOptions();

    await this.setPatientOptions(options);
    this.showOrHideObsList();
    this.setPatientFieldMessage(
      t('js.pcc_lookup.found_matching_vips', { count: options.length })
    );
  }

  get headers() {
    return {
      'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')
        ?.content,
      'Content-type': 'application/json; charset=UTF-8',
    };
  }
}
